export const ICONS = {
  // will eventually be generated automatically with the SVGs
  add: require('static/icons/add.svg'),
  addBlue: require('static/icons/add-blue.svg'),
  addFriend: require('static/icons/add-friend.svg'),
  addGrey: require('static/icons/add-grey.svg'),
  alert: require('static/icons/alert.svg'),
  alertBlack: require('static/icons/alert-black.svg'),
  alertSmall: require('static/icons/alert-small.svg'),
  alertTriangle: require('static/icons/alert-triangle.svg'),
  announcement: require('static/icons/announcement.svg'),
  arrowChartUp: require('static/icons/arrow-chart-up.svg'),
  arrowDottedDown: require('static/icons/arrow-dotted-down.svg'),
  bellNotificationSmall: require('static/icons/bell-notification-small.svg'),
  dottedLine: require('static/icons/dotted-line.svg'),
  blocked: require('static/icons/blocked.svg'),
  blueLock: require('static/icons/blue-lock.svg'),
  book: require('static/icons/book.svg'),
  brokenLink: require('static/icons/broken-link.svg'),
  bulb: require('static/icons/bulb.svg'),
  calendar: require('static/icons/calendar.svg'),
  calendarCheckmark: require('static/icons/calendar-checkmark.svg'),
  calendarBlue: require('static/icons/calendar-blue.svg'),
  calendarDark: require('static/icons/calendar-dark.svg'),
  calendarLight: require('static/icons/calendar-light.svg'),
  calendarSync: require('static/icons/sync-event.svg'),
  californiaPrivacyChoices: require('static/icons/california-privacy-choices.svg'),
  cardsClose: require('static/icons/cards-close.svg'),
  chartBlue: require('static/icons/chart-blue.svg'),
  checkmark: require('static/icons/checkmark.svg'),
  checkmarkInCircle: require('static/icons/checkmark-in-circle.svg'),
  checkmarkInCircleThick: require('static/icons/checkmark-in-circle-thick.svg'),
  checkmarkInCircleThickGreen: require('static/icons/check-circle-green.svg'),
  checkSparkle: require('static/icons/check-sparkle.svg'),
  chevronDown: require('static/icons/chevron-down.svg'),
  chevronRight: require('static/icons/chevron-right.svg'),
  calendarConfirmed: require('static/icons/calendar-confirmed.svg'),
  chevronRightThin: require('static/icons/chevron-right-thin.svg'),
  classpassLogo: require('static/icons/classpass-logo.svg'),
  clipboard: require('static/icons/clipboard.svg'),
  clock: require('static/icons/clock.svg'),
  clockGreen: require('static/icons/clock-green.svg'),
  cog: require('static/icons/cog.svg'),
  concierge: require('static/icons/concierge.svg'),
  cookie: require('static/icons/cookie.svg'),
  copy: require('static/icons/copy.svg'),
  copy2: require('static/icons/copy2.svg'),
  cross: require('static/icons/cross.svg'),
  crossInCircle: require('static/icons/cross-in-circle.svg'),
  crossRegularCircle: require('static/icons/cross-regular-circle.svg'),
  crossSmall: require('static/icons/cross-small.svg'),
  dollar: require('static/icons/dollar.svg'),
  dragHandle: require('static/icons/drag-handle.svg'),
  dropdownCaret: require('static/icons/dropdown-caret.svg'),
  dumbbell: require('static/icons/dumbbell.svg'),
  dumbbellBlue: require('static/icons/dumbbell-blue.svg'),
  dumbbellDark: require('static/icons/dumbbell-dark.svg'),
  dumbbellLight: require('static/icons/dumbbell-light.svg'),
  edit: require('static/icons/edit.svg'),
  editPencil: require('static/icons/edit-pencil.svg'),
  editPencilSku: require('static/icons/edit-pencil-sku.svg'),
  error: require('static/icons/notifications/error.svg'),
  envelope: require('static/icons/envelope.svg'),
  eye: require('static/icons/eye.svg'),
  eyeWithCross: require('static/icons/eye-with-cross.svg'),
  eyeWithCrossDark: require('static/icons/eye-with-cross-dark.svg'),
  fileImport: require('static/icons/import.svg'),
  filterVertical: require('static/icons/filter-vertical.svg'),
  flag: require('static/icons/flag.svg'),
  foodAndBeverage: require('static/icons/food-and-beverage.svg'),
  foodAndBeverageBlue: require('static/icons/food-and-beverage-blue.svg'),
  foodAndBeverageLight: require('static/icons/food-and-beverage-light.svg'),
  gears: require('static/icons/gears.svg'),
  googleGLogo: require('static/icons/google-g-logo.svg'),
  graph: require('static/icons/graph.svg'),
  history: require('static/icons/history.svg'),
  homePfe: require('static/icons/home-pfe.svg'),
  hourglass: require('static/icons/hourglass.svg'),
  inbox: require('static/icons/inbox.svg'),
  info: require('static/icons/info.svg'),
  infoBrand: require('static/icons/info-brand.svg'),
  infoGrey: require('static/icons/notifications/info-grey.svg'),
  infoGreyLight: require('static/icons/info-grey-light.svg'),
  infoYellow: require('static/icons/info-yellow.svg'),
  itemList: require('static/icons/item-list.svg'),
  invitePhones: require('static/icons/invite-user-phones.svg'),
  leftArrow: require('static/icons/left-arrow.svg'),
  leftArrowSquare: require('static/icons/left-arrow-square.svg'),
  lock: require('static/icons/lock.svg'),
  logout: require('static/icons/logout.svg'),
  lookingGlass: require('static/icons/lookingGlass.svg'),
  lotusFlower: require('static/icons/lotusFlower.svg'),
  marketingGraph: require('static/icons/notifications/marketing-graph.svg'),
  megaphoneGreen: require('static/icons/megaphone-green.svg'),
  members: require('static/icons/members.svg'),
  newUser: require('static/icons/new-user.svg'),
  noSymbol: require('static/icons/no-symbol.svg'),
  noDataLegend: require('static/icons/no-data-legend.svg'),
  notepad: require('static/icons/notepad.svg'),
  opportunitiesStroke: require('static/icons/opportunities-stroke.svg'),
  paper: require('static/icons/paper.svg'),
  pencilFilled: require('static/icons/pencil-filled.svg'),
  plus: require('static/icons/plus.svg'),
  pointUp: require('static/icons/point-up.svg'),
  practitionersEmpty: require('static/icons/practitioners-empty.svg'),
  priceTagBlue: require('static/icons/price-tag-blue.svg'),
  pulse: require('static/icons/pulse.svg'),
  questionMark: require('static/icons/questionMark.svg'),
  releaseSpotsTime: require('static/icons/release-spots-time.svg'),
  resourcesEmpty: require('static/icons/resources-empty.svg'),
  rightArrow: require('static/icons/right-arrow.svg'),
  rocket: require('static/icons/rocket.svg'),
  save: require('static/icons/checkmark-green.svg'),
  schedule: require('static/icons/schedule.svg'),
  searchGlasBlue: require('static/icons/search-1.svg'),
  searchGlass: require('static/icons/search-glass.svg'),
  searchGlassOutline: require('static/icons/search-glass-outline.svg'),
  servicesEmpty: require('static/icons/services-empty.svg'),
  settingsSliders: require('static/icons/settings-sliders.svg'),
  settingsSliders48Full: require('static/icons/settings-sliders-48-full.svg'),
  shieldCheck: require('static/icons/shield-check-nofill.svg'),
  shieldCheckSmall: require('static/icons/shield.svg'),
  socialCopy: require('static/icons/social-copy.svg'),
  socialFacebook: require('static/icons/social-facebook.svg'),
  socialFacebookSquare: require('static/icons/social-facebook-square.svg'),
  socialTwitter: require('static/icons/social-twitter.svg'),
  spinner: require('static/icons/spinner.svg'),
  star: require('static/icons/star.svg'),
  store: require('static/icons/store.svg'),
  storefront: require('static/icons/onboarding/storefront.svg'),
  success: require('static/icons/notifications/success.svg'),
  sun: require('static/icons/sun.svg'),
  swap: require('static/icons/swap.svg'),
  tagHollow: require('static/icons/tag-hollow.svg'),
  timer: require('static/icons/timer.svg'),
  trashCan: require('static/icons/trash-can.svg'),
  trashCanBlack: require('static/icons/trash-can-black.svg'),
  trashCanRed: require('static/icons/trash-can-red.svg'),
  trendingUp: require('static/icons/trending-up.svg'),
  trendingDown: require('static/icons/trending-down.svg'),
  trendingDownBold: require('static/icons/trend-down-arrow-bold.svg'),
  trendingUpBlue: require('static/icons/trending-up-blue.svg'),
  trendingUpBold: require('static/icons/trend-up-arrow-bold.svg'),
  trendingUpCircle: require('static/icons/trending-up-circle.svg'),
  twoArrowsCircle: require('static/icons/two-arrows-circle.svg'),
  twoArrowsCircleBackground: require('static/icons/two-arrows-circle-background.svg'),
  upcoming: require('static/icons/tab-upcoming.svg'),
  userAdd: require('static/icons/user-add.svg'),
  userMissedPickup: require('static/icons/user-missed-pickup.svg'),
  usersBlue: require('static/icons/users-blue.svg'),
  video: require('static/icons/video.svg'),
  warningYellow: require('static/icons/notifications/warning-yellow.svg'),
  yoga: require('static/icons/yoga.svg'),
  filledDot: require('static/icons/filled-dot.svg'),
  openExternal: require('static/icons/open-external.svg'),
};

export const ILLUSTRATIONS = {
  chartBars: require('static/illustrations/SmartSpot/chart-bars.svg'),
  dashboard: require('static/illustrations/SmartSpot/dashboard.svg'),
  dotGraph: require('static/illustrations/SmartSpot/dot-graph.svg'),
  emailSent: require('static/illustrations/email-sent.svg'),
  emptySpots: require('static/illustrations/AutoSync/empty-spots.svg'),
  errorTools: require('static/illustrations/error-tools.svg'),
  exerciseBikes: require('static/illustrations/SmartSpot/exercise-bikes.svg'),
  fillEmpty: require('static/illustrations/Pricing/fill-empty.svg'),
  fillHigh: require('static/illustrations/Pricing/fill-high.svg'),
  fillLow: require('static/illustrations/Pricing/fill-low.svg'),
  fillMedium: require('static/illustrations/Pricing/fill-medium.svg'),
  gift: require('static/illustrations/gift.svg'),
  highFive: require('static/illustrations/high-five.svg'),
  itemTag: require('static/illustrations/item-tag.svg'),
  laptop: require('static/illustrations/laptop.svg'),
  phone: require('static/illustrations/phone.svg'),
  pilates: require('static/illustrations/SmartSpot/pilates.svg'),
  autoSyncHero: require('static/illustrations/AutoSync/auto-sync-hero.svg'),
  unfilledRate: require('static/illustrations/Pricing/unfilled-rate.svg'),
  dynamicRate: require('static/illustrations/Pricing/dynamic-rate.svg'),
  classPass: require('static/illustrations/classpass.svg'),
  duplicate: require('static/illustrations/duplicate.svg'),
  dynamicPricing: require('static/illustrations/dynamic-pricing.svg'),
  pricingEmpty: require('static/illustrations/Pricing/pricing-empty.svg'),
  pricingFull: require('static/illustrations/Pricing/pricing-full.svg'),
  rocket: require('static/illustrations/rocket.svg'),
  calSync: {
    landing: require('static/illustrations/CalSync/calsync-landing.svg'),
    tutorial: {
      screenOne: require('static/illustrations/CalSync/tutorial-1.svg'),
      screenTwo: require('static/illustrations/CalSync/tutorial-2.svg'),
      screenTwoICal: require('static/illustrations/CalSync/tutorial-2-ical.svg'),
      screenThree: require('static/illustrations/CalSync/tutorial-3.svg'),
      screenFour: require('static/illustrations/CalSync/tutorial-4.svg'),
      screenFourICal: require('static/illustrations/CalSync/tutorial-4-ical.svg'),
    },
  },
};

export const PFE_ICONS = {
  appointments: require('static/icons/appointments.svg'),
  attended: require('static/icons/attended.svg'),
  checkmarkInCircleOutline: require('static/icons/checkmark-in-circle-outline.svg'),
  checkmarkInCircleBlack: require('static/icons/checkmark-in-circle-black.svg'),
  chevronDown: require('static/icons/chevron-down.svg'),
  chevronDownSmall: require('static/icons/chevron-down-small.svg'),
  chevronRight: require('static/icons/chevron-right.svg'),
  chevronRightThin: require('static/icons/chevron-right-thin.svg'),
  dollar30x48Full: require('static/icons/dollar-30x48-full.svg'),
  dynamic: require('static/icons/dynamic.svg'),
  earningPotential: require('static/icons/earning-potential.svg'),
  editPencilOutline: require('static/icons/edit-pencil-outline.svg'),
  envelopeOutline: require('static/icons/envelope-outline.svg'),
  filter: require('static/icons/filter.svg'),
  insights: require('static/icons/insights.svg'),
  logo: require('static/icons/logo.svg'),
  logotype: require('static/icons/logotype.svg'),
  manageClass: require('static/icons/manage-class.svg'),
  megaphone: require('static/icons/megaphone.svg'),
  notification: require('static/icons/notification.svg'),
  missed: require('static/icons/missed.svg'),
  money: require('static/icons/money.svg'),
  opportunitiesFill: require('static/icons/opportunities-fill.svg'),
  revenue: require('static/icons/revenue.svg'),
  shieldCheck: require('static/icons/shield-check.svg'),
  smartSpotGraph: require('static/icons/smart-spot-graph.svg'),
  smartSpotShield: require('static/icons/smart-spot-shield.svg'),
  smartSpotShieldOutline: require('static/icons/smart-spot-shield-outline.svg'),
  tag: require('static/icons/tag.svg'),
  threeDots: require('static/icons/threeDots.svg'),
  userFill: require('static/icons/user-fill.svg'),
  users: require('static/icons/users.svg'),
};

export const CONFIDENCE_ICONS = {
  amenity: require('static/icons/amenity.svg'),
  capacity: require('static/icons/capacity.svg'),
  contactless: require('static/icons/contactless.svg'),
  distancing: require('static/icons/distancing.svg'),
  mask: require('static/icons/mask.svg'),
  policy: require('static/icons/policy.svg'),
  bottle: require('static/icons/spray-bottle.svg'),
  thermometer: require('static/icons/thermometer.svg'),
  vaccination: require('static/icons/vaccination.svg'),
  ventilation: require('static/icons/ventilation-fan.svg'),
};

export const NAV_ICONS = {
  appointments: require('static/icons/nav/appointments.svg'),
  businessProfile: require('static/icons/nav/business-storefront.svg'),
  calendar: require('static/icons/nav/calendar.svg'),
  calsync: require('static/icons/nav/calsync.svg'),
  chart: require('static/icons/nav/chart.svg'),
  cog: require('static/icons/nav/cog.svg'),
  envelope: require('static/icons/nav/envelope.svg'),
  graph: require('static/icons/nav/graph.svg'),
  home: require('static/icons/nav/home-pfe.svg'),
  link: require('static/icons/nav/link.svg'),
  notepad: require('static/icons/nav/notepad.svg'),
  opportunities: require('static/icons/nav/opportunities.svg'),
  question: require('static/icons/nav/questionMark.svg'),
  resources: require('static/icons/nav/resources.svg'),
  smartSpot: require('static/icons/nav/smart-spot.svg'),
  speaker: require('static/icons/nav/speaker.svg'),
  star: require('static/icons/nav/star.svg'),
  tag: require('static/icons/nav/tag.svg'),
};

export const CONTACTS_ICONS = {
  facebook: require('static/icons/contacts/facebook.svg'),
  instagram: require('static/icons/contacts/instagram.svg'),
  phone: require('static/icons/contacts/phone.svg'),
  twitter: require('static/icons/contacts/twitter.svg'),
  website: require('static/icons/contacts/website.svg'),
};

export const SMARTSPOT_PERFORMANCE_BY_LOCALE = {
  'en-US': require('static/illustrations/SmartSpot/smartspot-performance.png'),
  sv: require('static/illustrations/SmartSpot/smartspot-performance-sv.png'),
  da: require('static/illustrations/SmartSpot/smartspot-performance-da.png'),
  'de-DE': require('static/illustrations/SmartSpot/smartspot-performance-de-DE.png'),
  es: require('static/illustrations/SmartSpot/smartspot-performance-es.png'),
  'fr-FR': require('static/illustrations/SmartSpot/smartspot-performance-fr-FR.png'),
  ja: require('static/illustrations/SmartSpot/smartspot-performance-ja.png'),
  nb: require('static/illustrations/SmartSpot/smartspot-performance-nb.png'),
  'nl-NL': require('static/illustrations/SmartSpot/smartspot-performance-nl-NL.png'),
  pt: require('static/illustrations/SmartSpot/smartspot-performance-pt.png'),
  'pt-BR': require('static/illustrations/SmartSpot/smartspot-performance-pt-BR.png'),
};
